import * as React from "react";

export const PlusBigIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" fill="none" viewBox="0 0 37 37">
    <path stroke="#1973FF" strokeLinecap="round" strokeWidth="3" d="M1.5 19.053h34M17.951 1.5v34"></path>
  </svg>
);
